// Inline SVG fallback used when a Bokun image URL fails to load (404, CORS,
// network error). Encoded as a data URI so it works offline and never causes
// another network request.
export const TOUR_IMAGE_FALLBACK =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 300' role='img' aria-label='Imagen no disponible'>
      <defs>
        <linearGradient id='g' x1='0' y1='0' x2='1' y2='1'>
          <stop offset='0%' stop-color='#fff1e6'/>
          <stop offset='100%' stop-color='#ffd9b3'/>
        </linearGradient>
      </defs>
      <rect width='400' height='300' fill='url(#g)'/>
      <g fill='#c2410c' opacity='0.55' transform='translate(160 110)'>
        <path d='M40 0 L80 60 L0 60 Z'/>
        <circle cx='60' cy='20' r='10'/>
        <rect x='-10' y='55' width='100' height='25' rx='4'/>
      </g>
      <text x='200' y='220' font-family='system-ui,sans-serif' font-size='16' fill='#9a3412' text-anchor='middle' font-weight='600'>Mostrando México</text>
    </svg>`,
  );

/** Robust <img onError> handler — swap broken Bokun image to local fallback. */
export function handleTourImgError(
  e: React.SyntheticEvent<HTMLImageElement, Event>,
) {
  const img = e.currentTarget;
  if (img.dataset.fallbackApplied === "1") return;
  img.dataset.fallbackApplied = "1";
  // With a `w`-descriptor srcset present the browser re-selects a candidate
  // from the source set and ignores `src`, so the srcset must go first.
  img.srcset = "";
  img.removeAttribute("srcset");
  img.sizes = "";
  img.removeAttribute("sizes");
  img.src = TOUR_IMAGE_FALLBACK;
}

